import { render, staticRenderFns } from "./EditWorkerLeader.vue?vue&type=template&id=25b8fbc7"
import script from "./EditWorkerLeader.vue?vue&type=script&lang=js"
export * from "./EditWorkerLeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports